import { useState } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { useToaster } from '@components/toaster';

import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

import { adManagerAddTemplate } from './api';

export const ADManagerAddTemplateModal = (props: ModalProps) => {
  const { t } = useStore();
  const { closeModal } = props;
  const { showSuccess, showError } = useToaster();
  const [templateName, setTemplateName] = useState('');

  const client = useQueryClient();
  const addTemplate = useMutation(() => adManagerAddTemplate(templateName), {
    onSuccess: () => {
      client.invalidateQueries(['ad-manager-templates']);
      showSuccess(t('integrations.admanager.settings.templates.add.success'));
      closeModal();
    },
    onError: () => {
      showError(t('integrations.admanager.settings.templates.add.error'));
    },
  });

  return (
    <Stack space={6}>
      <Text font="heading1" text={t('integrations.admanager.settings.templates.header')} />
      <TextField
        onChange={setTemplateName}
        label={t('integrations.admanager.settings.templates.label')}
      />
      <Stack space={4} orientation="horizontal" justify={'flex-end'}>
        <Button
          variant="secondary"
          text={t('common.forms.button.cancel')}
          onClick={closeModal}
          isDisabled={addTemplate.isLoading}
        />
        <Button
          text={t('integrations.admanager.settings.templates.button.submit')}
          onClick={() => addTemplate.mutate()}
          isDisabled={addTemplate.isLoading}
        />
      </Stack>
    </Stack>
  );
};
